// extracted by mini-css-extract-plugin
export default {"Slot":"Slot_Slot__dy6Uw","Highlighted":"Slot_Highlighted__BwxeB","embiggen":"Slot_embiggen__vdVMJ"};